<template>
  <div>
    <WechatBar v-if="visithost != 'smaco2.uestc.edu.cn'" />
    <v-app style="background: #fafafa;">
      <v-card flat tile class="pt-5">
        <v-card-title class="mb-3">
          <v-layout justify-center>
            <v-layout column justify-center>
              <v-flex xs12>
                <div style="text-align: justify">
                  <span
                    style="font-weight: bold;color:green;font-size: 24px;width:100%;display: inline-block"
                    >{{
                      $store.state.uAuth === "教工"
                        ? act_special[$route.params.action || "in"]
                        : $store.state.uAuth +
                          "用户，" +
                          act[$route.params.action || "in"]
                    }}！</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-list>
          <template v-for="(opt, i) in opts">
            <v-divider v-if="opt.divider" :key="i + 'divider'"></v-divider>
            <v-list-item
              v-if="opt.icon || opt.title || opt.subTitle"
              :key="i"
              style="height: 48px;"
            >
              <v-list-item-action>
                <v-layout>
                  <v-icon>{{ opt.icon }}</v-icon>
                  <span style class="ml-2 mr-2">{{ opt.subTitle }}</span>
                </v-layout>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  :class="
                    opt.title.indexOf('学生') !== -1 ||
                    opt.title.indexOf('研究生') !== -1 ||
                    opt.title.indexOf('继教生') !== -1
                      ? ''
                      : ''
                  "
                  v-if="opt.type === ''"
                >
                  <v-layout justify-end>
                    <h2>{{ opt.title.trim() || "N/A" }}</h2>
                  </v-layout>
                </v-list-item-title>
                <v-list-item-title
                  :class="[opt.title ? 'primary--text' : 'grey--text']"
                  v-else
                >
                  <v-layout justify-end>
                    <h3 style="width: 180px">
                      <Marquee :lists="opt.arr"></Marquee>
                    </h3>
                  </v-layout>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-subheader v-if="opt.subheader" :key="i + 'subheader'">
              {{ opt.subheader }}
            </v-subheader>
          </template>
        </v-list>
        <v-layout justify-center>
          <v-btn
            tile
            color="primary"
            :to="$store.getters.canGenCode ? '/code' : '/code-fake'"
            >前往个人二维码</v-btn
          >
        </v-layout>
        <v-row no-gutters class="mt-6 mb-3 justify-center">
          <v-img
            contain
            @click="jumpReal()"
            :class="'logo-' + genEncodedInfo()"
            src="@/assets/bwc_logo.png"
            max-width="50px"
          />
        </v-row>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import { time } from "@/utils/time";

import Marquee from "@/components/Marquee";
import WechatBar from "@/components/WechatBar";

export default {
  name: "tempSelfSign",
  data: () => ({
    act: {
      in: "入校授权有效",
      out: "出校登记成功"
    },
    act_special: {
      in: "入校授权有效",
      out: "出校授权有效"
    },
    visithost: location.host
  }),
  computed: {
    opts() {
      return [
        { divider: true },
        {
          icon: "mdi-account",
          title: this.$store.state.uName,
          subTitle: "用户姓名",
          style: "font-weight:bold",
          type: ""
        },
        {
          icon: "mdi-account-multiple",
          title: this.$store.state.uType,
          subTitle: "登记类型",
          style: "font-weight:bold",
          type: ""
        },
        {
          icon: "mdi-timer-outline",
          title: time.stringify(new Date().getTime()),
          subTitle: "登记时间",
          style: "font-weight:bold",
          type: "Marquee",
          arr: [time.stringify(new Date().getTime())]
        }
      ];
    }
  },
  methods: {
    genEncodedInfo() {
      return window.btoa("loginId=123456");
    },
    jumpReal() {
      if (this.$store.state.uID && this.$store.state.uPass)
        this.$ajax
          .post(
            "https://smaco2.uestc.edu.cn/shiroApi/auth/thirdpart/login?pipe=uestc-portal",
            {
              username: this.$store.state.uID,
              password: this.$store.state.uPass,
              verifyKey: ""
            }
          )
          .then(resp => {
            console.log(resp);
            if (resp.data.status !== 0)
              window.location =
                "https://smaco2.uestc.edu.cn/wx/tempSelfSign?controllerId=1000016%247%240%240";
          });
    }
  },
  components: {
    Marquee,
    WechatBar
  }
};
</script>

<style scoped>
.pt-5 {
  padding-top: 48px !important;
}
.v-btn {
  -webkit-box-align: center;
  align-items: center;
  border-radius: 2px;
  display: -webkit-inline-box;
  display: inline-flex;
  height: 36px;
  -webkit-box-flex: 0;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 500;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 6px 8px;
  min-width: 88px;
  outline: 0;
  text-transform: uppercase;
  text-decoration: none;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
